import _ from 'lodash';
import { createSelector } from 'reselect';

import { getComponentSettings } from '../../selectors/settings-selectors';
import { getMembersMap } from '../members/selectors';
import { getBadgeDefinition } from '../badges-definitions/selectors';

const MAX_MEMBER_COUNT_ON_TOO_MANY_TO_COUNT = 1000;

export const getPageLayout = (state) => state.membersPage.pageLayout;

export const getMembersLayout = createSelector([getComponentSettings, getPageLayout], (componentSettings, pageLayout) =>
  pageLayout !== null ? pageLayout : componentSettings.layoutStyle || 0,
);

export const getMembersCount = (state) =>
  state.membersPage.metadata.tooManyToCount ? MAX_MEMBER_COUNT_ON_TOO_MANY_TO_COUNT : state.membersPage.metadata.count;

export const getDisplayMembersCount = (state) => !state.membersPage.metadata.tooManyToCount;

export const getPage = (state) => state.membersPage.metadata.page;

export const getMembersIdList = (state) => state.membersPage.idList;

const getSearch = (state) => state.membersPage.search;

export const getFilter = (state) => state.membersPage.filter;

const getSort = (state) => state.membersPage.sort;

export const getBadgeId = (state) => state.membersPage.badgeId;

export const getQuery = createSelector(
  getSearch,
  getFilter,
  getSort,
  getBadgeId,
  (search, filter, sort, badgeId, privacyStatus) =>
    _.omitBy(
      {
        search,
        filter,
        sort,
        privacyStatus,
        badgeId,
      },
      _.isUndefined,
    ),
);

export const getMembers = createSelector([getMembersMap, getMembersIdList], (membersMap, idList) =>
  _.map(idList, (id) => _.get(membersMap, id)),
);

export const isMembersLoading = (state) => state.membersPage.isLoading;

export const getBadge = (state) => getBadgeDefinition(state, getBadgeId(state));
